import React, { useState, useEffect } from 'react'
import axios from 'axios';

import { url_root } from '../config'; // Importiere die Konfigurationsdaten

import '../components/PopupDatasheet.css'
import './new_pages.css'


function KnittingmachineConfigurationNew ({ 
  closeNewPopup, 
  fields, 
  sortedThreadTensionUnitOptions, 
  sortedSpeedUnitOptions, 
  sortedCulletDepthUnitOptions, 
  sortedHauloffAdjustmentOptions,
  sortedSinkerAdjustmentUnitOptions, 
  formatTimestampNow, 
  fetchMachineConfiguration, 
  copiedData, 
  newSaveID,  
  convertCommaToDotForFloatFields, 
  setDefaultForEmptyNumberFields, 
  handleFocus, 
  handleBlur, 
  validateField, 
  setErrors, 
  errors, 
  setErrorMessage,
  setShowErrorModal}) {


  const access_token = window.localStorage.getItem('access_token');

  /* post-State Objekt, um Daten zu speichern, die vom Nutzer eingegeben werden */
  const [post, setPost] = useState ({
    // machine_configuration:
    id_machine_configuration: '',
    machine_configuration_name: '',
    machinetype_name: '',
    product: '',
    yarn_feeder: '',
    additional_special_feeder: '',
    thread_tension: '',
    unit_thread_tension_name: '',
    carriage_speed: '',
    unit_carriage_speed_name: '',
    cullet_depth: '',
    unit_cullet_depth_name: '',
    hauloff_adjustment: '',
    unit_hauloff_adjustment_name: '',
    inserter_for_weft_thread: false,
    builtin_rail_warp_threads: false,
    sinker_adjustment: '',
    unit_sinker_adjustment_name: '',
    machine_configuration_others: '',
    machine_configuration_all_can_read: false, 
    timestamp: '',
    // Datenblatt, Bild
    datasheet: '',
    filename: '',
  })
  

  useEffect(() => {
    // Wenn kopierter Datensatz vorhanden ist, setze ihn in den Zustand
    if (copiedData) {
      setPost(copiedData);
    }
    }, [copiedData]); // Ueberwache Aenderungen an kopierten Daten


  // Funktion, um Benutzereingaben in Formularfeldern zu verarbeiten
  const handleInput = (event) => {
    const { name, type, value, checked } = event.target;
    setPost(prevPost => ({
      ...prevPost,
      [name]: type === 'checkbox' ? checked : value,
    }));
    if (errors[name]) {
      setErrors(prevErrors => ({
        ...prevErrors,
        [name]: null,
      }));
    }
  }


  // Funktion zum Speichern eines neuen Maschinentpys mit aktuellem Zeitstempel
  const handleNewSave = async () => {
    let newErrors = {};
    try {
      // Schritt 1: Alle Felder auf Leerwert pruefen und Fehler sammeln
      fields.forEach((field) => {
        const value = String(post[field.name] || ''); // Standardwert auf leer setzen, falls undefined
        const rules = field.validate || {};
        
        // Validierung aufrufen und Fehler im neuen Fehlerobjekt speichern
        const error = validateField(field.name, value, rules, (errorObj) => {
          newErrors = { ...newErrors, ...errorObj };
        });
        
        if (error) {
          newErrors[field.name] = error;
        }
      });

      // Schritt 2: Fehler im Zustand speichern
      setErrors(newErrors);

      // Schritt 3: Ueberpruefen, ob Fehler vorhanden sind
      const hasErrors = Object.values(newErrors).some((error) => error !== '');

      if (hasErrors) {
        // Zeige das Modal, wenn noch Fehler vorhanden sind
        setErrorMessage("Bitte korrigieren Sie die fehlerhaften Felder, bevor Sie speichern.");
        setShowErrorModal(true);
        return; // Stoppe das Speichern, bis die Fehler behoben sind
      }

      // Fehler zuruecksetzen, falls alles korrekt ist
      setErrors({});

      const id_machinetype = parseInt(window.localStorage.getItem('id_machinetype'), 10);
      const timestamp = formatTimestampNow(); // Aktuellen Zeitstempel abrufen und formatieren
      const newPost = { ...post, id_machinetype, timestamp }; // Zeitstempel zum neuen Eintrag hinzufügen

      // Setze leere Float- und Integer-Felder auf -123
      setDefaultForEmptyNumberFields(newPost, fields);
      // Konvertiere Komma in Punkt nur bei Feldern mit { float: true }
      convertCommaToDotForFloatFields(newPost, fields);

      const response = await axios.post(`${url_root}/new_knit_machine_configuration`, newPost,
          {
            headers: {
                'Authorization': `Bearer ${access_token}`
            }
          }
      );

      // Ueberpruefen des Statuscodes in der API-Antwort
      const statusCode = response.status;
      if (statusCode === 242) {
        setErrorMessage("Dieser Name für Maschinenkonfiguration ist schon vergeben.");
        setShowErrorModal(true);
        return;
      } else if (statusCode === 241) {
        setErrorMessage("Bitte geben Sie eine Bezeichnung ein.");
        setShowErrorModal(true);
        return;
      }

      const id_machine_configuration = response.data.id_machine_configuration;

      /* Auffrischen der id_machinetype, da sonst undefined und die Tabelle dadurch leer angezeigt wird 
        nach Aufruf fetchMachineConfiguration */
      const refreshIdMachinetype = response.data.id_machinetype;
      window.localStorage.setItem('id_machinetype', refreshIdMachinetype);

      fetchMachineConfiguration(); // Tabelle aktualisieren
      newSaveID(id_machine_configuration); // ID weitergeben, um den neuen Datensatz zu markieren
      closeNewPopup(); // Popup für neue Eintraege schließen
    } catch (error) {
      console.error('Fehler beim Speichern des neuen Eintrags:', error);
    }
  };
  

  return (   
    <div className='new-popup-page'>
      <div className='new-title'>
        <h3>Hier können Sie eine neue Maschinenkonfiguration anlegen:</h3>
      </div>

      {fields.filter(field => field.name !== 'machinetype_name').map(field => { // Filtern des machinetype_name-Felds 
        const fieldValue = post[field.name];
        // Setze den Wert auf einen leeren String, wenn er kleiner oder gleich 0 ist
        const displayValue = fieldValue < 0 ? '' : fieldValue;

        return (
        <div key={field.name} className="new-input-row">
          <label className={field.label.trim() === '' ? 'empty' : ''}>{field.label}</label>

          <div className="new-input-with-unit">
          {field.type === 'select' ? (
            <>
            <select 
              onChange={handleInput} 
              name={field.name} 
              value={displayValue}
              onFocus={(event) => handleFocus(event, setErrors)}
              onBlur={(event) => handleBlur(event, fields, {}, (name, value, rules) => 
                validateField(name, value, rules, setErrors))}
            >
              <option value=""></option>
            </select>
              {/* Fehlernachricht für das aktuelle select-Feld anzeigen */}
              {errors[field.name] && (
                <span className="error-message">{errors[field.name]}</span>
              )}
            </>
            
            ) : field.type === 'checkbox' ? (
              <div className="new-input-row-checkbox">
                <input
                  type="checkbox"
                  name={field.name}
                  checked={post[field.name]}
                  onChange={handleInput}
                />
              </div>
            ) : field.type === 'textarea' ? (
              <>
                <textarea className='textarea'
                  name={field.name}
                  value={displayValue}
                  onChange={handleInput}
                />
                {field.unit && (      // rendern nur, wenn field.unit einen Wert hat
                  <div>
                    <select // dropdown-Menu wird gerendert, wenn ein unit (Masseinheit) vorhanden ist
                      className="new-unit-dropdown"
                      name={field.unit} // Verwenden Sie field.unit direkt als name
                      value={post[field.unit]} // Verwenden Sie field.unit direkt, um den Wert aus post zu erhalten
                      onChange={handleInput}
                    >
                      <option value="" disabled> </option>
                      
                      {field.unit === 'unit_thread_tension_name' && sortedThreadTensionUnitOptions.length > 0 ? (
                        sortedThreadTensionUnitOptions.map((option, index) => (
                          <option key={index} value={option}>
                            {option}
                          </option>
                        ))
                      ) : field.unit === 'unit_carriage_speed_name' && sortedSpeedUnitOptions.length > 0 ? (
                        sortedSpeedUnitOptions.map((option, index) => (
                          <option key={index} value={option}>
                            {option}
                          </option>
                        ))
                      ) : field.unit === 'unit_cullet_depth_name' && sortedCulletDepthUnitOptions.length > 0 ? (
                        sortedCulletDepthUnitOptions.map((option, index) => (
                          <option key={index} value={option}>
                            {option}
                          </option>
                        ))
                      )  : field.unit === 'unit_hauloff_adjustment_name' && sortedHauloffAdjustmentOptions.length > 0 ? (
                        sortedHauloffAdjustmentOptions.map((option, index) => (
                          <option key={index} value={option}>
                            {option}
                          </option>
                        ))
                      ) : field.unit === 'unit_sinker_adjustment_name' && sortedSinkerAdjustmentUnitOptions.length > 0 ? (
                        sortedSinkerAdjustmentUnitOptions.map((option, index) => (
                          <option key={index} value={option}>
                          { option}
                          </option>
                        ))
                    ) : null}
                  </select>

                  {field.unit === 'unit_thread_tension_name' && errors.unit_thread_tension_name && (
                    <span className="error-message">{errors.unit_thread_tension_name}</span>)}
                  {field.unit === 'unit_carriage_speed_name' && errors.unit_carriage_speed_name && (
                    <span className="error-message">{errors.unit_carriage_speed_name}</span>)}
                  {field.unit === 'unit_cullet_depth_name' && errors.unit_cullet_depth_name && (
                    <span className="error-message">{errors.unit_cullet_depth_name}</span>)}
                  {field.unit === 'unit_hauloff_adjustment_name' && errors.unit_hauloff_adjustment_name && (
                    <span className="error-message">{errors.unit_hauloff_adjustment_name}</span>)}
                  {field.unit === 'unit_sinker_adjustment_name' && errors.unit_sinker_adjustment_name && (
                    <span className="error-message">{errors.unit_sinker_adjustment_name}</span>)}

                </div> 

                )}
              </>
            ) : (
              <>
                <input
                  type={field.type}
                  name={field.name}
                  value={displayValue}
                  onChange={handleInput}

                  onFocus={(event) => handleFocus(event, setErrors)}
                  onBlur={(event) => handleBlur(event, fields, {}, (name, value, rules) => 
                    validateField(name, value, rules, setErrors))}    
                />
                {errors[field.name] && <span className="error-message">{errors[field.name]}</span>}

                {field.unit && (                  
                  <div>
                    <select
                      className="new-unit-dropdown"
                      name={field.unit}
                      value={post[field.unit]}
                      onChange={handleInput}
                    >
                      <option value="" disabled> </option>
                      
                      {field.unit === 'unit_thread_tension_name' && sortedThreadTensionUnitOptions.length > 0 ? (
                        sortedThreadTensionUnitOptions.map((option, index) => (
                          <option key={index} value={option}>
                            {option}
                          </option>
                      ))
                      ) : field.unit === 'unit_carriage_speed_name' && sortedSpeedUnitOptions.length > 0 ? (
                        sortedSpeedUnitOptions.map((option, index) => (
                          <option key={index} value={option}>
                            {option}
                          </option>
                      ))
                      ) : field.unit === 'unit_cullet_depth_name' && sortedCulletDepthUnitOptions.length > 0 ? (
                        sortedCulletDepthUnitOptions.map((option, index) => (
                          <option key={index} value={option}>
                            {option}
                          </option>
                      ))
                      ) : field.unit === 'unit_hauloff_adjustment_name' && sortedHauloffAdjustmentOptions.length > 0 ? (
                        sortedHauloffAdjustmentOptions.map((option, index) => (
                          <option key={index} value={option}>
                            {option}
                          </option>
                      ))
                      ) : field.unit === 'unit_sinker_adjustment_name' && sortedSinkerAdjustmentUnitOptions.length > 0 ? (
                        sortedSinkerAdjustmentUnitOptions.map((option, index) => (
                          <option key={index} value={option}>
                            {option}
                          </option>
                      ))
                    )  : null}
                  </select>
                  
                  {field.unit === 'unit_thread_tension_name' && errors.unit_thread_tension_name && (
                    <span className="error-message">{errors.unit_thread_tension_name}</span>)}
                  {field.unit === 'unit_carriage_speed_name' && errors.unit_carriage_speed_name && (
                    <span className="error-message">{errors.unit_carriage_speed_name}</span>)}
                  {field.unit === 'unit_cullet_depth_name' && errors.unit_cullet_depth_name && (
                    <span className="error-message">{errors.unit_cullet_depth_name}</span>)}
                  {field.unit === 'unit_hauloff_adjustment_name' && errors.unit_hauloff_adjustment_name && (
                    <span className="error-message">{errors.unit_hauloff_adjustment_name}</span>)}
                  {field.unit === 'unit_sinker_adjustment_name' && errors.unit_sinker_adjustment_name && (
                    <span className="error-message">{errors.unit_sinker_adjustment_name}</span>)}

                </div>
                )} 
              </>
            )}
          </div>
        </div>
        );
      })}

      <div className='new-input-save-cancel'>
        <button onClick={() => closeNewPopup()}>ABBRECHEN</button> 
        <button onClick={() => handleNewSave()}>SPEICHERN</button>       
      </div>

    </div>    
  )
}

export default KnittingmachineConfigurationNew
